(() => {
  const storageKey = 'uzRecentlyViewedBacksplashes';
  const currentNode = document.querySelector('[data-uz-current-product]');
  const section = document.querySelector('[data-uz-recently-viewed]');
  const rail = document.querySelector('[data-uz-recently-viewed-rail]');
  if (!currentNode || !section || !rail) return;

  try {
    const current = JSON.parse(currentNode.textContent);
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    const previous = stored.filter((item) => item && item.handle !== current.handle).slice(0, 4);

    if (previous.length) {
      rail.innerHTML = previous.map((item) => `
        <a class="uz-recently-viewed__item" href="${escapeHtml(item.url)}">
          <span class="uz-recently-viewed__image"><img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="240" height="240"></span>
          <span class="uz-recently-viewed__title">${escapeHtml(item.title)}</span>
          <span class="uz-recently-viewed__price">${escapeHtml(item.price)}</span>
        </a>`).join('');
      section.hidden = false;
    }

    localStorage.setItem(storageKey, JSON.stringify([current, ...stored.filter((item) => item && item.handle !== current.handle)].slice(0, 8)));
  } catch (error) {
    // Browsing history is an enhancement; storage restrictions should not affect the product page.
  }

  function escapeHtml(value) {
    const element = document.createElement('span');
    element.textContent = String(value || '');
    return element.innerHTML;
  }
})();

